import React from 'react'
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap'
import { navigate } from '@reach/router'

export const BackListButton = ({ path = '/admin/inicio' }) => 
    <OverlayTrigger
      placement='bottom'
      overlay={
        <Tooltip>
         <strong>Regresar a la lista</strong>
        </Tooltip>
      }
    >
      <Button variant="info" onClick={ () => navigate(path) }>
        <i className="fa fa-arrow-left pr-1"></i>
        Regresar
      </Button>
    </OverlayTrigger>

